import React, {useEffect} from "react";
import css from "./RequestHelpHeader.css";
import useStarfishAPI from 'hooks/useStarfishAPI';

const RequestHelpHeader = () => {

  const [studentHelpContentResponse, callStudentHelpContentAPI] = useStarfishAPI();

  useEffect(() => {
    callStudentHelpContentAPI("../student/getStudentHelpContent.html", {
      method: "GET",
    });
  }, []);

  return (
    <div className={css['header']}>
        <div className={css["header-first-line"]} tabIndex={0}>
            <span>
              Need assistance with something?
            </span>
        </div>
        {studentHelpContentResponse.success && studentHelpContentResponse.data.studentHelpContent &&
        <div className={css["header-second-line"]} tabIndex={0}
             dangerouslySetInnerHTML={{__html: studentHelpContentResponse.data.studentHelpContent}} />}
      </div>
  );

};

export default RequestHelpHeader;
